import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Store from 'lightningjs-redux';
import { httpRequestTimeout, request } from '@bedrock-rdk/utils';
import { getInitialStyle } from './lBanner.style';
import connect from './lBanner.connector';
import { setLBannerShow, setLBannerHide } from '../../../logic/player/player.constants';
import { fetchTrackers, track, validateCuePoints } from './lBanner.utils';

const LOAD_OFFSET = 10;

export class LBanner extends Lightning.Component {
  static _template() {
    return _merge(
      {
        rect: true,
        shader: {
          // In case if an L-Banner image is opaque
          type: Lightning.shaders.Hole,
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._trackers = [];
    this._cuePoints = [];
  }

  _attach() {
    this._unsubscribe = connect(this);
  }

  _detach() {
    if (this._unsubscribe) {
      this._unsubscribe();
      this._unsubscribe = null;
    }

    if (this._displayTimeout) {
      clearTimeout(this._displayTimeout);
    }

    this._shown = null;
    this._loaded = null;
    this._loadPoints = [];
    this._trackers = [];
    this._cuePoints = [];
  }

  show() {
    this.visible = true;
    track(this._trackers);
  }

  hide() {
    this.visible = false;
  }

  set elapsed(value) {
    if (this._lBannerState || !this._data || !this._cuePoints.length > 0) {
      return;
    }

    this._elapsed = value;

    // NEED TO LOAD
    if (!this._loaded && this._loadPoints.includes(value)) {
      this.loadData();
      this._loaded = true;
    }

    if (this._cuePoints.includes(value)) {
      if (this._shown[value] || !this.src) {
        return;
      }

      this._shown[value] = true;
      Store.dispatch(setLBannerShow());

      this._displayTimeout = setTimeout(() => {
        if (this._isPlayingAds) {
          return;
        }

        Store.dispatch(setLBannerHide());
      }, this._data.duration * 1000);
    }
  }

  set provider(value) {
    this._provider = value;
  }

  set isPlayingAds(value) {
    this._isPlayingAds = value;

    if (this._isPlayingAds && this._elapsed) {
      this._cuePoints = validateCuePoints(this._cuePoints, [this._elapsed]);
      this.processLoadPoints();
    }

    if (this._lBannerState && this._isPlayingAds) {
      Store.dispatch(setLBannerHide());
    }
  }

  set advertising(value) {
    this._advertising = value;

    if (!this._advertising || !this._advertising[this._provider]) {
      return;
    }

    // NOTE: use for fake L-Banner, tune cue points to your liking
    /*
    const host = `${window.location.href
      .replace(/\/index\.html.*$/, '')
      .replace(/\/#.*$/, '')}/static/assets/ads/L-banner.xml`;
    // Alternative: 'https://ad-ipd.sxp.smartclip.net/select?ang_api=2.7&ang_plrh=1080&ang_plrw=1920&ang_streamid=6c6fd006-4e0c-4063-afc2-3df9e7e97187&fwd_adb=0&fwd_br=1&fwd_cf=content_form&fwd_chc=b6e02b8c-d862-4ec7-8ba5-234c26447bcb&fwd_comp=0&fwd_conid=1269049&fwd_fsk=12&fwd_ip_test=nonlinear_test_image&fwd_j4=1%3A2&fwd_j5=1%3A2%3A3%3A4%3A5%3A6&fwd_mtc=22&fwd_nltype=sz&fwd_reqid=0c1155b9-2677-4d16-a763-3921506b11a3&fwd_vcd=2783&fwd_vpaid=1&plcmt=1&rnd=2855956570&s=rtlp_rtlplus%2Fsofties&schain=1.0%2C1%21ad-alliance.de%2Ccsid_22328928714%2C1%2C%2C&sz=over&tagver=6.4.11-release.1&type=vast4&vodid=cnJuOndhdGNoOnZpZGVvaHViOmVwaXNvZGU6MTAwOTg4Nw&vodprfx=10036a&fwd_reqid=838b839e-67f0-4668-bb96-bd0adea0e438'
    this._data = {
      cuePoints: [60, 120, 900],
      duration: 30,
      host,
    };
    */

    this._data = this._advertising[this._provider];
    this._shown = {};
    this._cuePoints = this._data.cuePoints || [];
    this.processLoadPoints();
  }

  loadData() {
    // eslint-disable-next-line no-console
    console.log('[L-Banner] Loading L-Banner:', this._data.host);

    request(this._data.host, { responseType: 'document', timeout: httpRequestTimeout })
      .then(manifest => {
        const src = (manifest.querySelector('StaticResource').textContent || '').trim();
        // eslint-disable-next-line no-console
        console.log(`[L-Banner] Loading image: "${src}"`);

        this._trackers = fetchTrackers(manifest);

        this.src = src;
        this.loadTexture();
      })
      .catch(() => {
        this.src = '';
      });
  }

  set lBannerState(value) {
    this._lBannerState = value;
  }

  set adMarkers(value) {
    if (!value.length) return;
    this._cuePoints = validateCuePoints(this._cuePoints, value);
    this.processLoadPoints();
  }

  processLoadPoints() {
    if (!this._cuePoints.length) {
      this._loadPoints = [];

      return;
    }
    this._loadPoints = this._cuePoints.flatMap(point =>
      Array.from({ length: LOAD_OFFSET }, (_, index) => point - index),
    );
  }
}
